module.exports = __webpack_public_path__ + "img/iconePedidosPendente.97dd81ae.png";